import styled from 'styled-components';

const FlatButtonRow = styled.div`
  display: flex;
  justify-content: ${props => props.justifyContent || 'space-between'};
`;

export default FlatButtonRow;
